import * as React from "react";
import "./ServerError.css";
import { MainTracker } from "../../PixelTrackers/MainTracker";
import { useEffect } from "react";
import * as translator from "../../utils/translator"
import { clientConfig } from "../../config";

export default function ServerError({ status = 500 }) {

  useEffect(() => {
    MainTracker.track("pv", `View ${status} Page`);
  }, []);

  const fullPath = window.location.pathname;
  /*
  We have to get the country this way because this component can render with every kind of bad url 
  for example funnel.doktorabc.com/account (no locale params),
  
  incase the urlSplits[0] is a not convinient (not DE/GB/FR etc...) the translator will return english
  */
  const country = translator.getCountryFromUrl(fullPath)
  const language = country ? translator.getLanguageByCountry(country) : "en";

  // urls
  const locale = country ? `${language}-${country.toUpperCase()}` : "en-GB";
  const linkToHomepage = country ? clientConfig.MAIN_WEBSITE_URL + '/' + translator.getCMSUrlPrefixByLocale(locale) : clientConfig.MAIN_WEBSITE_URL;
  const howItWorksUrl = clientConfig.MAIN_WEBSITE_URL + '/' + translator.translate(language, "default", `ServerError/how_it_works_url_${country?.toLowerCase() || 'uk'}`)


  const is404 = status === 404;
  const statusKey = is404 ? "404" : "500";
  const errorImage = `${clientConfig.IMAGES_URL}redesign_2025/general/${statusKey}/${statusKey}.png`;

  const title = translator.translate(language, "default", `ServerError/${statusKey}/title`);
  const description = translator.translate(language, "default", `ServerError/${statusKey}/description`);

  return (
    <div className="se-page">

      {/* ==================== DESKTOP ==================== */}
      <section className="se-desktop">
        <div className="se-card">
          <div className="se-content">
            <h1 className={`se-title ${is404 ? "se-title--404" : "se-title--500"}`}>
              {title}
            </h1>
            <p className={`se-description ${is404 ? "se-description--404" : "se-description--500"}`}>
              {description}
            </p>

            <div className="se-buttons">
              {!is404 && (
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="se-btn-primary"
                >
                  {translator.translate(language, "default", "ServerError/refresh_page")}
                </button>
              )}
              <a href={linkToHomepage} className="se-btn-primary">
                {translator.translate(language, "default", "ServerError/go_to_homepage")}
              </a>
            </div>

            <div className="se-links">
              {is404 && (
                <a href={howItWorksUrl} className="se-link">
                  {translator.translate(language, "default", "ServerError/how_it_works")}
                </a>
              )}
              <a href={`${clientConfig.FUNNEL_URL}/${country?.toLowerCase() || 'gb'}/contact`} className="se-link">
                {translator.translate(language, "default", "ServerError/contact_support")}
              </a>
            </div>
          </div>

          <div className="se-image-wrapper" aria-hidden="true">
            <img src={errorImage} alt="" className="se-image" />
          </div>
        </div>
      </section>

      {/* ==================== MOBILE ==================== */}
      <section className="se-mobile">
        <div className="se-mobile-image-card" aria-hidden="true">
          <img src={errorImage} alt="" className="se-mobile-image" />
        </div>

        <div className="se-mobile-content">
          <h1 className="se-mobile-title">{title}</h1>
          <p className="se-mobile-description">{description}</p>
          <div className="se-mobile-buttons">
            <a href={linkToHomepage} className="se-btn-primary se-btn-primary--mobile">
              {translator.translate(language, "default", "ServerError/go_to_homepage")}
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
